import { render, staticRenderFns } from "./listChat.vue?vue&type=template&id=7648fc2c&scoped=true&"
import script from "./listChat.vue?vue&type=script&lang=js&"
export * from "./listChat.vue?vue&type=script&lang=js&"
import style0 from "./listChat.vue?vue&type=style&index=0&id=7648fc2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7648fc2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
